<template>
    <div class="icon-New-Window"></div>
</template>